var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContactLocation = function SvgContactLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 21.6
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5092",
    transform: "translate(-905 -786)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 355",
    cx: 10.5,
    cy: 10.363,
    rx: 10.5,
    ry: 10.363,
    transform: "translate(905 786)",
    fill: "#E81E61",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(913 791)",
    fill: "none",
    stroke: "#E81E61",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18720",
    d: "M13 6.545C13 11.636 6.5 16 6.5 16S0 11.636 0 6.545a6.5 6.5 0 1 1 13 0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 117",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(3.5 3.75)"
  })))));
};
export default SvgContactLocation;